import { createApi } from '@reduxjs/toolkit/query/react';

import { CLAIM_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export interface TOCDetails {
    previous_supplier_npi: string;
    last_fill_date: string;
    drug_days_supply: number;
    product_service_oid: string;
    dosage_form?: string;
    drug_strength?: string;
    ndc?: string;
    quantity: number;
}

export const claimApi = createApi({
    baseQuery: getBaseQuery(CLAIM_API_URL, true),
    reducerPath: 'claimApi',
    endpoints: (build) => ({
        /** Checks if supplier can claim first refusal for the provided segment */
        getTOCDetails: build.query<
            TOCDetails | undefined,
            {
                payerId: string;
                referralId: string;
                productServiceOid: string;
            }
        >({
            query: ({ payerId, referralId, productServiceOid }) => ({
                url: `toc/${payerId}/referral/${referralId}/toc_details`,
                params: {
                    product_service_oid: productServiceOid,
                },
            }),
            transformResponse: (response: TOCDetails | null) => response ?? undefined,
            transformErrorResponse: handleRTKQueryError(
                'An error retrieving transition of care details.',
            ),
        }),
    }),
});

export const { useGetTOCDetailsQuery } = claimApi;
